import React from "react";
import { withStyles } from "@mui/styles";

import Table from "../../components/table/Table";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

const headings = [
  {
    label: "REASON",
    key: "reason",
  },
];

function AdjustmentReasonsTable({
  classes,
  adjustmentReasons,
  addButtonText,
  onAddButtonClick,
  hideSearch,
  onEditAdjustmentReason,
}) {
  return (
    <div className={classes.section}>
      <Table
        hideSearch={hideSearch}
        addButtonText={addButtonText}
        headings={headings}
        data={adjustmentReasons}
        onAddButtonClick={
          onAddButtonClick ? (payload) => onAddButtonClick(payload) : null
        }
        rowActions={[
          {
            type: "edit",
            onClick: onEditAdjustmentReason
              ? (adjustmentReason) => onEditAdjustmentReason(adjustmentReason)
              : null,
          },
        ]}
      />
    </div>
  );
}

export default withStyles(styles)(AdjustmentReasonsTable);
